import type { ReactNode } from "react";
import { SiteNavigation } from "@/components/layout/SiteNavigation";
import { FooterSection } from "@/sections/FooterSection/FooterSection";
import styles from "./InnerPageChrome.module.scss";

type InnerPageChromeProps = { currentPath: string; children: ReactNode };

export function InnerPageChrome({ currentPath, children }: InnerPageChromeProps) {
  return (
    <div className={`${styles.shell} experienceStage`} data-page-mode="editorial" data-chrome-surface="light">
      <SiteNavigation currentPath={currentPath} />
      <main className={styles.main}>{children}</main>
      <FooterSection />
    </div>
  );
}
